// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import actions from '../../../action-list';
import {getRelationship} from '../../../shared/repositories';

export const readRelationshipOptions = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getRelationship();

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_RELATIONSHIP_OPTIONS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/get-relationship-options.js